"use client";

import { useTransition } from "react";
import { setLang } from "@/lib/lang-actions";
import type { Lang } from "@/lib/i18n";

const OPTIONS: { lang: Lang; label: string; name: string }[] = [
  { lang: "en", label: "EN", name: "English" },
  { lang: "ar", label: "عربي", name: "العربية" },
];

/** tone "brand" sits on the receipt's merchant colour, "desk" on our own pages */
export function LangToggle({ lang, tone = "desk" }: { lang: Lang; tone?: "brand" | "desk" }) {
  const [pending, start] = useTransition();

  // the action sets the cookie, Next then re-renders the page in the new language
  function pick(next: Lang) {
    if (next !== lang) start(() => setLang(next));
  }

  const track = tone === "brand" ? "bg-[color-mix(in_srgb,var(--on-brand)_16%,transparent)]" : "bg-[#d7dce8]";
  const on = tone === "brand" ? "bg-paper text-ink" : "bg-paper text-ink shadow-sm";
  const off = tone === "brand" ? "text-[var(--on-brand)]" : "text-ink-soft";

  return (
    <div role="group" aria-label="Language" className={`no-print inline-flex rounded-full p-[3px] ${track} ${pending ? "opacity-70" : ""}`}>
      {OPTIONS.map((o) => (
        <button
          key={o.lang}
          type="button"
          lang={o.lang}
          aria-pressed={o.lang === lang}
          aria-label={o.name}
          onClick={() => pick(o.lang)}
          className={`min-h-11 min-w-[52px] rounded-full px-3 text-sm ${o.lang === lang ? `${on} font-medium` : off}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
